// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1wOtT","bigColWidth":"Table_bigColWidth__1l-8H","biggerColWidth":"Table_biggerColWidth__ntXr0","row":"Table_row__3QaU2","col":"Table_col__exm4f"};